import type { CardPointeIpgConfig } from './cardpointe-backend-config.types';
import { CardPointeRpaModuleName } from './cardpointe-rpa-module-names';
import { CardPointeIpgSystemId } from './cardpointe-system-constants';
import { CardPointeGatewayEnvironment } from './cardpointe-gateway-environment.types';

export const CardPointeIpgConfigProd: CardPointeIpgConfig = {
    ipg_id: CardPointeIpgSystemId,
    environment: CardPointeGatewayEnvironment.PRODUCTION,
    terminal_include_avs: false,
    name: 'CardPointe',
    urlPattern: 'https://cardpointe.cardconnect.com/*',
    workflow_prefix: 'cardpointe',
    allowedWebsites: [
        {
            type: 'ipg',
            system_id: CardPointeIpgSystemId,
            url: 'https://cardpointe.cardconnect.com',
            name: 'CardPointe Reporting Tool',
            allowedUrlPatterns: ['https://cardpointe.cardconnect.com/*'],
            sessionPersistence: 'persistent',
            promoteSessionCookies: false,
            urlPatternsRules: [],
            fetchDefaultAction: 'allow',
            iframeUrlPatterns: [],
            iframeDefaultAction: 'allow',
        },
    ],
    rpaModules: [CardPointeRpaModuleName.CARDPOINTE_IPG],
};

export const CardPointeIpgConfigDemo: CardPointeIpgConfig = {
    ...CardPointeIpgConfigProd,
    environment: CardPointeGatewayEnvironment.SANDBOX,
    urlPattern: 'https://cardpointe-uat.cardconnect.com/*',
    allowedWebsites: CardPointeIpgConfigProd.allowedWebsites.map((allowedWebsite) => ({
        ...allowedWebsite,
        url: 'https://cardpointe-uat.cardconnect.com',
        allowedUrlPatterns: ['https://cardpointe-uat.cardconnect.com/*'],
    })),
};

export function resolveCardPointeIpgConfigFromPreset(
    presetConfig: CardPointeIpgConfig,
    persistedConfig?: CardPointeIpgConfig
): CardPointeIpgConfig {
    return {
        ...presetConfig,
        allowedWebsites: presetConfig.allowedWebsites.map((presetAllowedWebsite) => ({
            ...presetAllowedWebsite,
            allowedUrlPatterns: [...presetAllowedWebsite.allowedUrlPatterns],
            urlPatternsRules: presetAllowedWebsite.urlPatternsRules.map((urlPatternsRule) => ({
                ...urlPatternsRule,
                urlPatterns: [...urlPatternsRule.urlPatterns],
            })),
            iframeUrlPatterns: presetAllowedWebsite.iframeUrlPatterns.map((urlPatternsRule) => ({
                ...urlPatternsRule,
                urlPatterns: [...urlPatternsRule.urlPatterns],
            })),
        })),
        rpaModules: [...presetConfig.rpaModules],
        ...(persistedConfig?.card_details_model === undefined
            ? {}
            : { card_details_model: persistedConfig.card_details_model }),
        ...(persistedConfig?.gateway_credential_uuid === undefined
            ? {}
            : {
                  gateway_credential_uuid: persistedConfig.gateway_credential_uuid,
              }),
        terminal_include_avs:
            persistedConfig?.terminal_include_avs ?? presetConfig.terminal_include_avs,
    };
}
